import axios from '@/utils/request';

// 获取商品列表
export const getProducts = (data: any) => {
  return axios.request({
    url: 'Integral/GetProducts',
    method: 'GET',
    params: data,
  });
};

// 获取可兑换商品列表
export const getConvertibleProducts = (data: any) => {
  return axios.request({
    url: 'Integral/GetConvertibleProducts',
    method: 'GET',
    params: data,
  });
};

// 兑换商品
export const exchangeProduct = (data: any) => {
  return axios.request({
    url: 'Integral/ExchangeProduct',
    method: 'POST',
    data,
  });
};

// 确认收货
export const sureOrder = (data: any) => {
  return axios.request({
    url: 'Integral/SureOrder',
    method: 'POST',
    params: data,
  });
};

// 获取积分规则
export const getIntegralRules = (data: any) => {
  return axios.request({
    url: 'Integral/GetIntegralRules',
    method: 'GET',
    params: data,
  });
};

// 获取我的积分信息
export const getMyIngtegral = (data: any) => {
  return axios.request({
    url: 'Integral/GetMyIntegral',
    method: 'GET',
    params: data,
  });
};

// 积分明细记录
export const getIntegralDetails = (data: any) => {
  return axios.request({
    url: 'Integral/GetIntegralDetails',
    method: 'GET',
    params: data,
  });
};

// 兑换记录
export const getIntegralOrders = (data: any) => {
  return axios.request({
    url: 'Integral/GetIntegralOrders',
    method: 'GET',
    params: data,
  });
};

// 获取地址列表
export const getAddresses = (data: any) => {
  return axios.request({
    url: 'Integral/GetAddresses',
    method: 'GET',
    params: data,
  });
};

// 新增&编辑地址
export const postAddress = (data: any) => {
  return axios.request({
    url: 'Integral/postAddress',
    method: 'POST',
    data,
  });
};

// 获取地址详情
export const getAddressDetails = (data: any) => {
  return axios.request({
    url: 'Integral/GetAddressDetails',
    method: 'GET',
    params: data,
  });
};

// 删除地址
export const delAddress = (data: any) => {
  return axios.request({
    url: 'Integral/DelAddress',
    method: 'POST',
    params: data,
  });
};

// 设置默认地址
export const setDefaultAddress = (data: any) => {
  return axios.request({
    url: 'Integral/SetDefaultAddress',
    method: 'POST',
    params: data,
  });
};
